import ufeApi from 'services/api/ufeApi';
import cookieUtils from 'utils/Cookies';

function unlinkBiAccount(input) {
    let url = '/api/bi/unlinkAccount';
    const { enableProfileAccountGroup = false } = Sephora.configurationSettings;

    if (enableProfileAccountGroup && cookieUtils.isRCPAccountAPIEnabled()) {
        url = '/gway/v2/bi/unlinkAccount';
    }

    return ufeApi
        .makeRequest(url, {
            method: 'POST',
            body: JSON.stringify(input)
        })
        .then(data => (data.errorCode ? Promise.reject(data) : data));
}

export default unlinkBiAccount;
